
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { KbGlobalMessageComponent } from './kb-global-message.component';


@NgModule({
    imports: [CommonModule, IconModule, I18nModule],
    declarations: [KbGlobalMessageComponent],
    exports: [KbGlobalMessageComponent],
})
export class KbGlobalMessageComponentModule { }
